import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParameterCodec, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { apiUrl } from '../http/api-url';

export interface AuthTokenResponse {
  successful: boolean;
  token: string;
}

class FormEncodingCodec implements HttpParameterCodec {
  encodeKey = (key: string) => encodeURIComponent(key);
  encodeValue = (value: string) => encodeURIComponent(value);
  decodeKey = (key: string) => decodeURIComponent(key);
  decodeValue = (value: string) => decodeURIComponent(value);
}

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly http = inject(HttpClient);

  authenticate(username: string, password: string): Observable<AuthTokenResponse> {
    const body = new HttpParams({ encoder: new FormEncodingCodec() })
      .set('username', username)
      .set('password', password);
    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
    return this.http.post<AuthTokenResponse>(apiUrl('/auth/login'), body, { headers });
  }

  refreshAccessToken(refreshToken: string): Observable<AuthTokenResponse> {
    return this.http.post<AuthTokenResponse>(apiUrl(`/auth/access_token/refresh/${refreshToken}`), null);
  }

  invalidateAccessToken(): Observable<unknown> {
    return this.http.put(apiUrl('/auth/access_token/invalidate'), null);
  }
}
